/**
 * 由 DOM **属性**累乘出「元素局部坐标 → root 用户坐标」的矩阵。
 *
 * 为什么需要它（而不是直接用 getCTM）：jsdom 不实现 getCTM/getScreenCTM，
 * 而 M1 的验收硬指标是「编组 → 解组后每个元素的坐标不变」。
 * 本函数只看 transform 属性，故可在 jsdom 里精确断言；
 * 真实浏览器里它同时是 getCTM 结果的独立交叉验证。
 */
import { IDENTITY, mul, type Mat } from './matrix';
import { parseTransformList } from './transform';

export function modelMatrixToRoot(el: Element, root: Element): Mat {
  const chain: Element[] = [];
  for (let cur: Element | null = el; cur && cur !== root; cur = cur.parentElement) chain.push(cur);
  let m: Mat = IDENTITY;
  for (let i = chain.length - 1; i >= 0; i--) {
    const node = chain[i] as Element;
    m = mul(m, parseTransformList(node.getAttribute('transform')).mat);
  }
  return m;
}

/** 两个矩阵是否在容差内相等（坐标守恒断言的比较器） */
export const matAlmostEqual = (a: Mat, b: Mat, eps = 1e-9): boolean =>
  a.every((v, i) => Math.abs(v - (b[i] as number)) < eps);
